module.exports = __webpack_public_path__ + "static/media/speech_07.44b0a29a.svg";